<template>
  <div class="collapse_item__wrappers">
    <div>
      <el-row :gutter="10" class="d-flex align-items-center">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 18 }"
          :lg="{ span: 18 }"
        >
          <div>
            <div class="justify-content-start d-flex">
              <div class="text-truncate" v-if="taskInfo.parentTskOverview">
                <TskText :content="taskInfo.parentTskOverview">
                  <el-link
                    :ref="'link'"
                    :underline="false"
                    type="primary"
                    @click="openEditPage()"
                  >
                    {{ taskInfo.parentTskOverview }}
                  </el-link>
                </TskText>
              </div>
              <div v-if="taskInfo.parentTskOverview">
                <el-link
                  class="ml-1 mr-1"
                  :underline="false"
                  type="primary"
                  @click="openEditPage()"
                >
                  {{ '/' }}
                </el-link>
              </div>
              <div>
                <el-link
                  :underline="false"
                  type="primary"
                  @click="openEditPage()"
                >
                  {{ taskInfo.tskInfoNo }}
                </el-link>
              </div>
            </div>
          </div>
          <TskText :content="taskInfo.tskOverview">
            <span class="task_overview"> {{ taskInfo.tskOverview }}</span>
          </TskText>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 6 }"
        >
          <div class="justify-content-end d-flex">
            <el-tag
              class="mr-2"
              size="mini"
              :type="
                taskInfo.tskStatus == 'N'
                  ? 'info'
                  : taskInfo.tskStatus == 'P'
                  ? ''
                  : taskInfo.tskStatus == 'Y'
                  ? 'success'
                  : 'danger'
              "
            >
              {{ taskInfo.v_tskStatus }}
            </el-tag>
            <el-tag
              size="mini"
              effect="dark"
              :type="taskInfo.tskImportantLevel"
            >
              {{ taskInfo.v_tskImportantLevel }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="d-flex align-items-center">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="d-flex align-items-center">
            <div class="task-info mb-1 mt-1">
              <div class="task_create align-items-center">
                <div class="task__type_icon mr-2">
                  <img
                    :src="
                      taskInfo.createByMemImgUrl ||
                      '/image/static/img/nopic.jpg'
                    "
                  />
                </div>
                <div class="task-info__task">
                  <div class="create_by">{{ taskInfo.createByName }}</div>
                  <div class="create_time">
                    Create at {{ taskInfo.createDate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <div class="justify-content-end d-flex">
            <div
              style="text-align: center"
              class="mr-10"
              v-if="taskInfo.tskStatus != 'D' && taskInfo.tskStatus != 'Y'"
            >
              <el-dropdown trigger="click" @command="optCommand">
                <el-button size="mini" plain class="br-4">
                  {{ $l('btn_cancel_more') || '更多' }}
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(opt, index) in tableOpts"
                    :key="index"
                    :icon="opt.icon"
                    :command="{ opt, data: taskInfo }"
                    :divided="opt.divided"
                    :disabled="
                      opt.disabled == undefined ? false : opt.disabled(taskInfo)
                    "
                  >
                    {{ opt.text }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-button
                size="mini"
                class="br-4"
                v-if="!disabled && isAgent && allow('M')"
                @click="modi"
                plain
                >{{ $l('btn_assignments') || '分配任务' }}</el-button
              >
              <el-button
                size="mini"
                class="br-4"
                v-if="taskInfo.tskStatus != 'D'"
                @click="$emit('openRemarkEdit')"
                plain
                >{{ $l('btn_remark') || '备注' }}</el-button
              >
              <el-button
                size="mini"
                class="br-4 mr-10"
                v-if="isStart"
                @click="updateTskStatus()"
                plain
                >{{ $l('btn_action_task') || '开始任务' }}</el-button
              >

              <el-button
                size="mini"
                class="br-4 mr-10"
                v-if="isCompleted"
                @click="updateTskStatus()"
                plain
                >{{ $l('btn_completed_task') || '完成' }}</el-button
              >

              <el-button
                size="mini"
                class="br-4 mr-10"
                v-if="isRestart"
                @click="updateTskStatus()"
                plain
                >{{ $l('btn_completed_restart') || '重启任务' }}</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="collapse_item__header mb-1 mt-2">
      <div class="collapse_item__header_icon">
        <span @click="toggle">
          <div v-if="!closed()" class="icon_class">
            <i class="el-icon-arrow-down" style="font-weight: 800" />
          </div>
          <div v-else class="icon_class">
            <i class="el-icon-arrow-right" style="font-weight: 800" />
          </div>
        </span>
      </div>
      <div class="collapse_item__header_text" @click="toggle">
        <slot name="title">
          <span>{{ $l('table_task_description') || '任务描述' }}</span>
        </slot>
      </div>
    </div>
    <div class="collapse_item__body">
      <el-collapse-transition>
        <div v-show="!closed()" class="mt-3">
          <slot />
        </div>
      </el-collapse-transition>
    </div>

    <el-dialog
      append-to-body
      :title="$l('dialog_title_choose_tskBy') || '选择经办人'"
      :visible.sync="chooseTskByDialogVisible"
      v-if="chooseTskByDialogVisible"
      width="30%"
    >
      <el-form
        class="mt-2"
        ref="form"
        :model="formData"
        :rules="rules"
        size="mini"
        label-width="100px"
        label-position="right"
      >
        <el-form-item :label="$l('form_label_tskBy') || '经办人'" prop="tskBy">
          <dict-select
            v-model="formData.tskBy"
            :selectedLabel.sync="formData.tskByName"
            url="/master/common/dict/baseUserSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$l('form_label_task_remark') || '备注'"
          prop="remark"
        >
          <el-input
            type="textarea"
            :rows="8"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            v-model="formData.remark"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseTskByDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="assignments()" type="primary" size="small">{{
          $l('INDEX.tips_confirm') || '确定'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TskText from './tsk-text.vue'
import tableOpts from './table-opts'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapState } from 'vuex'

export default {
  mixins: [EditLoading],
  components: { TskText },
  props: {
    title: { type: String, default: '' },
    taskInfo: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    isSuper: { type: Boolean, default: false },
  },
  inject: ['open', 'close', 'toggle', 'closed'],
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    ...mapState('admin/user', ['info']),
    isRestart() {
      const { userCode } = this.info
      const { createBy } = this.taskInfo
      return (
        (createBy === userCode || this.isSuper) &&
        this.taskInfo.tskStatus == 'Y'
      )
    },
    isCreateChild() {
      const { userCode } = this.info
      const { createBy, tskBy, tskStatus } = this.taskInfo
      return (
        (createBy === userCode || tskBy === userCode || this.isSuper) &&
        ['A', 'N', 'P'].includes(tskStatus)
      )
    },
    isAgent() {
      const { userCode } = this.info
      const { createBy, tskBy, tskStatus } = this.taskInfo
      return (
        (createBy === userCode || tskBy === userCode || this.isSuper) &&
        ['A', 'N', 'P'].includes(tskStatus)
      )
    },
    isCancal() {
      const { userCode } = this.info
      const { createBy, tskStatus } = this.taskInfo
      return (
        (createBy === userCode || this.isSuper) &&
        ['A', 'N', 'P'].includes(tskStatus)
      )
    },
    isStart() {
      const { userCode } = this.info
      const { tskBy, tskStatus } = this.taskInfo
      return (
        (tskBy === userCode || this.isSuper) && ['A', 'N'].includes(tskStatus)
      )
    },
    isCompleted() {
      const { userCode } = this.info
      const { tskBy, tskStatus } = this.taskInfo
      return (tskBy === userCode || this.isSuper) && ['P'].includes(tskStatus)
    },
  },
  data() {
    return {
      tskButton2StatusMap: {
        N: {
          text: this.$l('btn_action_task') || '开始任务',
          next: 'P',
        },
        P: {
          text: this.$l('btn_completed_task') || '完成',
          next: 'Y',
        },
        Y: {
          text: this.$l('btn_completed_restart') || '重启任务',
          next: 'N',
        },
      },
      chooseTskByDialogVisible: false,
      formData: {
        tskBy: '',
        tskByName: '',
        tskInfoCode: '',
        remark: '',
      },
      rules: {
        tskBy: [
          {
            trigger: 'change',
            required: true,
            message: this.$l('INDEX.tips_pleaseSelectData') || '请选择数据',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    openEditPage() {
      if (!this.taskInfo.parentTskCode) return
      this.$router.push({
        name: 'personal-taskCenter-detail',
        params: { code: this.taskInfo.parentTskCode, pageType: 'detail' },
        query: { tskInfoNo: this.taskInfo.parentTskNo },
      })
    },
    async assignments() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .personalTskInfoAssignmentsApi({
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.chooseTskByDialogVisible = false
      this.$emit('reload')
    },
    modi() {
      this.formData.tskBy = this.taskInfo.tskBy || ''
      this.formData.tskByName = this.taskInfo.tskByName || ''
      this.formData.tskInfoCode = this.taskInfo.tskInfoCode || ''
      this.chooseTskByDialogVisible = true
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'create':
          this.$emit('create')
          break
        case 'delete':
          this.del(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    del({ tskInfoCode }) {
      this.$confirm(
        this.$l('tips_cancel_task') || '是否要取消任务？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .personalTskInfoCancelApi({ tskInfoCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_cancel_task_ok') || '取消成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    updateTskStatus() {
      if (this.loadingOpen()) return
      this.$api
        .personalTskInfoTskStatusApi({
          tskInfoCode: this.taskInfo.tskInfoCode,
          tskStatus: this.tskButton2StatusMap[this.taskInfo.tskStatus].next,
        })
        .then((res) => {
          this.loadingClose()
          if (res) {
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('reload')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse_item__wrappers {
  .collapse_item__header {
    display: flex;
    align-items: center;
    .collapse_item__header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      margin-right: 6px;
      .icon_class {
        background-color: rgba(9, 30, 66, 0.08);
        height: 15px;
        width: 15px;
        line-height: 15px;
        border-radius: 5px;
        text-align: center;
        color: #344563;
      }
    }
    .collapse_item__header_text {
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .task-info {
    display: flex;
    justify-content: space-between;
    .task_create {
      display: flex;
      .task__type_icon {
        min-width: 48px;
        min-height: 48px;
        > img {
          width: 48px;
          height: 48px;
          border-radius: 5px;
        }
      }

      .create_by {
        color: #101010;
        font-size: 14px;
        font-weight: 600;
        margin-top: 2px;
      }
      .create_time {
        color: #6c757d;
        font-size: 14px;
      }
    }
  }
  .collapse_item__body {
    margin-left: 21px;
  }
}
.icon_class:hover {
  background-color: rgba(9, 30, 66, 0.13) !important;
}
.task_overview {
  color: #4f4f4f;
  font-size: 14px;
  font-weight: 600;
}

.justify-content-end {
  justify-content: end;
}
@media only screen and (max-width: 767px) {
  .justify-content-end {
    justify-content: start !important;
  }
}
@media only screen and (min-width: 768px) {
  .justify-content-end {
    justify-content: start !important;
  }
}
@media only screen and (min-width: 1200px) {
  .justify-content-end {
    justify-content: end !important;
  }
}

@media only screen and (min-width: 992px) {
  .justify-content-end {
    justify-content: end !important;
  }
}

.br-4 {
  border-radius: 4px !important;
}
.mr-10 {
  margin-right: 10px;
}

.el-link::v-deep:hover {
  text-decoration: none;
}
::v-deep {
  .el-link {
    display: inline;
  }
}
</style>
